var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.1 48.91"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Layer 2",
    d: "M10.26 18.3H0v12.28h10.26v8.72L28.8 24.5h.2l-.08-.06.08-.06h-.2L10.26 9.57zM36.27 0H21.41v3.49h11.2a1.81 1.81 0 011.82 1.82V43.6a1.81 1.81 0 01-1.82 1.82h-11.2v3.49h14.87a1.83 1.83 0 001.82-1.82V1.82A1.83 1.83 0 0036.28 0",
    fill: "#999"
  })))));
}
export default SvgFirstSession;